import { render, staticRenderFns } from "./accommodation.vue?vue&type=template&id=a455822a&scoped=true"
import script from "./accommodation.vue?vue&type=script&lang=js"
export * from "./accommodation.vue?vue&type=script&lang=js"
import style0 from "./accommodation.vue?vue&type=style&index=0&id=a455822a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a455822a",
  null
  
)

export default component.exports